export default "__VITE_ASSET__HWJ9WWRg__"